'use client';

import React from 'react';

export default function DateRangeGlobalStyles() {
  return (
    <style jsx global>{`
      @media (max-width: 768px) {
        .custom-date-range-picker-dropdown .ant-picker-range-wrapper {
          width: 92vw;
          max-width: 480px;
          max-height: 70vh;
          background: #fff;
          border-radius: 12px;
          padding: 12px;
          overflow-y: auto;
          -webkit-overflow-scrolling: touch;
          position: relative;
        }
        .custom-date-range-picker-dropdown .ant-picker-panel-container {
          max-width: 92vw;
          overflow-x: auto;
          -webkit-overflow-scrolling: touch;
          touch-action: pan-x;
          overscroll-behavior-x: contain;
          white-space: nowrap;
          scrollbar-width: thin;
        }
        .custom-date-range-picker-dropdown .ant-picker-panels {
          display: inline-flex;
          gap: 12px;
          overflow-x: auto;
          -webkit-overflow-scrolling: touch;
          touch-action: pan-x;
          overscroll-behavior-x: contain;
          scroll-snap-type: x mandatory;
        }
        .custom-date-range-picker-dropdown .ant-picker-panel {
          min-width: 85vw;
          flex: 0 0 auto;
          scroll-snap-align: start;
        }
        .custom-date-range-picker-dropdown .date-range-footer {
          position: sticky;
          bottom: 0;
          left: 0;
          right: 0;
          background: #fff;
          padding: 12px;
          border-top: 1px solid #eee;
          display: flex;
          justify-content: flex-end;
          gap: 8px;
        }
        .custom-date-range-picker-dropdown .date-range-accept-btn {
          background: #1677ff;
          color: #fff;
          border: none;
          border-radius: 8px;
          padding: 8px 16px;
          font-weight: 600;
        }
        .custom-date-range-picker-dropdown .ant-picker-presets {
          max-height: 35vh;
          overflow-y: auto;
          -webkit-overflow-scrolling: touch;
          padding-right: 8px;
        }
      }
    `}</style>
  );
}
